import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { massForceDeleteRoles } from "../../api/apiRoles";
import parseError from "../../utils/parseError";

export const useMassForceDeleteRoles = () => {
    const queryClient = useQueryClient();
    const { mutate: massForceDeleteRolesMutate, isPending } = useMutation({
        mutationFn: massForceDeleteRoles,
        onSuccess: (res) => {
            toast.success(res.message || "Roles permanently deleted");
            queryClient.invalidateQueries(["roles"]);
        },
        onError: (e) => toast.error(parseError(e) || "Failed to force delete roles"),
    });
    return { massForceDeleteRolesMutate, isPending };
};
